import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import { makeStyles } from '@material-ui/core/styles'
import useSettingsStyles from 'pages/pga-coach/settings/settings.styles'

export const ONBOARDING_STEP_KEYS = [
  'coachProfileCreated',
  'facilityAdded',
  'availabilityAdded',
  'schedulableCreated',
]

export const getOnboardingProgress = coachOnboardingProgress => {
  const completedCount = ONBOARDING_STEP_KEYS.filter(
    key => coachOnboardingProgress?.[key] !== null,
  ).length
  const totalSteps = ONBOARDING_STEP_KEYS.length

  return {
    completedCount,
    totalSteps,
    progressValue: (completedCount / totalSteps) * 100,
    progressPercent: Math.floor((completedCount / totalSteps) * 100),
  }
}

const useStyles = makeStyles(theme => ({
  progressSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  progressMeta: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  progressBar: {
    flex: 1,
    height: 8,
    borderRadius: 4,
    backgroundColor: 'rgba(0, 83, 255, 0.15)',
  },
  bar: {
    borderRadius: 4,
    backgroundColor: '#0053FF',
  },
  progressLabel: {
    flexShrink: 0,
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
}))

const OnboardingProgressSection = ({ coachOnboardingProgress, className }) => {
  const classes = useStyles()
  const settingsStyles = useSettingsStyles()
  const { completedCount, totalSteps, progressValue } = getOnboardingProgress(
    coachOnboardingProgress,
  )

  return (
    <Box className={`${classes.progressSection} ${className || ''}`}>
      <Typography component="h2" className={settingsStyles.sectionEyebrow}>
        Let&apos;s get you set up
      </Typography>
      <Box className={classes.progressMeta}>
        <LinearProgress
          color="primary"
          variant="determinate"
          value={progressValue}
          classes={{
            root: classes.progressBar,
            barColorPrimary: classes.bar,
          }}
        />
        <Typography component="p" className={classes.progressLabel}>
          {completedCount} of {totalSteps} complete
        </Typography>
      </Box>
    </Box>
  )
}

OnboardingProgressSection.propTypes = {
  coachOnboardingProgress: PropTypes.shape({
    coachProfileCreated: PropTypes.string,
    facilityAdded: PropTypes.string,
    availabilityAdded: PropTypes.string,
    schedulableCreated: PropTypes.string,
  }),
  className: PropTypes.string,
}

export default OnboardingProgressSection
